(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaLastUpdateDateDialogController', RcopiaLastUpdateDateDialogController);

    RcopiaLastUpdateDateDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'RcopiaLastUpdateDate'];

    function RcopiaLastUpdateDateDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                                   RcopiaLastUpdateDate) {
        var vm = this;

        vm.rcopiaLastUpdateDate = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rcopiaLastUpdateDate.id !== null) {
                RcopiaLastUpdateDate.update(vm.rcopiaLastUpdateDate, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:rcopiaLastUpdateDateUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
